/**
 * Default base64-encoded image URL.
 * This is a small placeholder image encoded in base64 format.
 * @constant {string}
 */
export const defaultBase64ImageUrl =
  // eslint-disable-next-line max-len
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAQAAAAnOwc2AAAAEUlEQVR42mOsb2LAAIxDWRAAffYKFcUj22sAAAAASUVORK5CYII=';
